import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bulls-eye',
  templateUrl: './bulls-eye.component.html',
  styleUrls: ['./bulls-eye.component.scss']
})
export class BullsEyeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
